import React, { createContext, PropsWithChildren, useContext } from 'react';
import { ILogger } from 'shared/types';

export interface ILoggerContext {
    logger: ILogger;
}

const initialContext: ILoggerContext = {
    logger: {
        log: console.log,
        warn: console.warn,
        error: console.error,
    },
};

const LoggerContext = createContext<ILoggerContext>(initialContext);

export const LoggerProvider: React.FC<PropsWithChildren<ILoggerContext>> = ({
    logger,
    children,
}) => <LoggerContext.Provider value={{ logger }}>{children}</LoggerContext.Provider>;

export const useLogger = () => useContext<ILoggerContext>(LoggerContext);
